import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, deleteRequest, postRequest } from 'utils/http'

export const useGetVideos = () => {
  return useQuery({
    queryKey: ['videos'],
    queryFn: async () => {
      const response = await getRequest('/videos')
      return response.data
    },
  })
}

export const useCreateVideo = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (formData) => {
      const response = await postRequest('/videos', formData)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['videos'] })
    },
  })
}

export const useUpdateVideo = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, updatedData }) => {
      const response = await postRequest(`/videos/${id}?_method=PUT`, updatedData)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['videos'] })
    },
  })
}

export const useDeleteVideo = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id) => {
      const response = await deleteRequest(`/videos/${id}`)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['videos'] })
    },
  })
}
